import { Badge } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { UserProfileProjectAssignment } from '@texas/api/endpoints/userProfilesApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';

export function userProfileProjectColumns(t: TFunction, onClose: () => void) {
  const helper = createColumnHelper<UserProfileProjectAssignment>();
  return [
    helper.accessor('name', {
      header: t('project.projectName'),
      cell: (info) => info.getValue(),
    }),
    helper.accessor('erpId', {
      header: t('general.code'),
      cell: (info) => info.getValue(),
    }),
    helper.accessor('customerName', {
      header: t('general.customer'),
      cell: (info) => (
        <AngularNavLink
          to="customer"
          navobj={{ customerId: info.row.original.customerId }}
          onClick={onClose}
        >
          {info.getValue()}
        </AngularNavLink>
      ),
    }),
    helper.accessor('customerIdentifier', {
      header: t('userDetails.brandCode'),
      cell: (info) => info.getValue(),
    }),
    helper.accessor('countryCode', {
      header: t('project.country'),
      cell: (info) => info.getValue(),
    }),
    helper.accessor('archived', {
      header: t('general.state'),
      cell: (info) => (
        <Badge
          bg={
            info.getValue()
              ? 'status.archivedBackground'
              : 'status.successBackground'
          }
          color={info.getValue() ? 'status.archivedText' : 'status.success'}
        >
          {info.getValue() ? t('general.archived') : t('userDetails.active')}
        </Badge>
      ),
    }),
  ].map((column) => ({ ...column, enableSorting: false }));
}
